import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'secondary' | 'ghost';
const base = 'inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-[0.8125rem] font-medium tracking-[0.08em] uppercase transition-all duration-500 ease-editorial focus:outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-2 focus-visible:ring-offset-ivory';
const variants: Record<Variant, string> = {
  primary: 'bg-charcoal text-ivory hover:bg-mocha',
  secondary: 'border border-charcoal/20 text-charcoal hover:border-charcoal/60 hover:bg-charcoal/[0.03]',
  ghost: 'text-charcoal hover:text-mocha px-0 py-0 rounded-none'
};
type Props = {
  to?: string;
  href?: string;
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
};
export function Button({
  to,
  href,
  variant = 'primary',
  children,
  className = '',
  type = 'button',
  onClick
}: Props) {
  const classes = `${base} ${variants[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} data-id="element-27" data-mp="i0jx7nx12ckb">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} target="_blank" rel="noreferrer" data-id="element-28" data-mp="3bx6kq1y9yds">
        {children}
      </a>;
  }
  return <button type={type} onClick={onClick} className={classes} data-id="element-29" data-mp="89oznnebzqjk">
      {children}
    </button>;
}